/** Marker returned by home-health-api when PHI access has timed out (HIPAA §164.312(a)(1)). */
export const STEP_UP_REQUIRED_ERROR = "STEP_UP_REQUIRED";

const EVENT_PREFIX = "HCF Admin Web App (V2):";

export const STEP_UP_EVENTS = {
  REQUIRED_SHOWN: `${EVENT_PREFIX} PHI step-up required`,
  COMPLETED: `${EVENT_PREFIX} PHI step-up completed`,
  CANCELLED: `${EVENT_PREFIX} PHI step-up cancelled`,
  FAILED: `${EVENT_PREFIX} PHI step-up failed`,
} as const;
